/**
 * handlers/persona.ts
 * Persona loading, selection, and DOM application.
 */

import { state, savePersona } from '../state';
import { dom } from '../dom';
import { getPersona as apiGetPersona, updatePersona as apiUpdatePersona } from '../api';
import { showToast } from '../ui-renderers';

function _applyPersonaToDOM(persona: string) {
  if (dom.drawer) dom.drawer.dataset.persona = persona;
  document.querySelectorAll('.ai-persona-card').forEach(card => {
    const el = card as HTMLElement;
    el.classList.toggle('active', el.dataset.persona === persona);
    el.setAttribute('aria-checked', el.dataset.persona === persona ? 'true' : 'false');
  });
}

/**
 * Load the current user's persona from the API and update state + UI.
 */
export async function loadPersona() {
  try {
    const data = await apiGetPersona();
    if (data.persona) {
      state.persona = data.persona;
      savePersona(data.persona);
      _applyPersonaToDOM(data.persona);
    }
  } catch (_) { /* best effort */ }
}

/**
 * Handle persona card selection — save to backend and update UI.
 */
export async function handlePersonaChange(persona: string) {
  state.persona = persona;
  savePersona(persona);
  _applyPersonaToDOM(persona);
  try {
    await apiUpdatePersona(persona);
    showToast('Persona updated — Kili will adapt in the next message.');
  } catch (_) {
    showToast('Could not save persona. Will retry.', 'error');
  }
}
